import React from 'react';

interface Props {
  children: React.ReactNode;
  colSpan: number;
}

/**
 * Renders a table caption that will repeat on the next page in a PDF if the table breaks.
 */
export const PDFSafeTableHeaderCaption = ({ children, colSpan }: Props) => {
  return (
    <tr className="hasCaption">
      <th colSpan={colSpan}>{children}</th>
    </tr>
  );
};
